import { BulkImportsHistory } from '@/features/bulkImportsHistory';

export default function BulkImportsHistoryPage() {
  return <BulkImportsHistory />;
}
